import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';

import { TranslationModule } from '@lib/translation';

import { SnTextTransformerComponent } from './components/text-transformer';
import { SnUserLastActiveComponent } from './components/user-last-active';
import {
  FsFormatDatePipe,
  FsMilesToDistancePipe,
  FsReverseArrayPipe,
  FsStateConvertPipe,
  FsPhoneNumberPipe,
  SnDateDurationPipe,
  SnFilesizePipe,
  SnLinkifyPipe,
  SnSafeUrlPipe,
  FsTimeDurationPipe,
  SnTimeToNowPipe,
  FsFormatColorPipe,
  SnLabelPipe,
} from './pipes';

@NgModule({
  imports: [CommonModule, TranslationModule],
  exports: [
    CommonModule,
    RouterModule,
    MatRippleModule,
    SnFilesizePipe,
    FsTimeDurationPipe,
    SnTimeToNowPipe,
    SnDateDurationPipe,
    SnTextTransformerComponent,
    SnUserLastActiveComponent,
    SnSafeUrlPipe,
    SnLabelPipe,
    SnLinkifyPipe,
    FsFormatDatePipe,
    FsMilesToDistancePipe,
    FsReverseArrayPipe,
    FsStateConvertPipe,
    FsFormatColorPipe,
    FsPhoneNumberPipe,
  ],
  declarations: [
    SnLinkifyPipe,
    SnSafeUrlPipe,
    SnFilesizePipe,
    FsTimeDurationPipe,
    SnTimeToNowPipe,
    SnDateDurationPipe,
    SnTextTransformerComponent,
    SnUserLastActiveComponent,
    SnLabelPipe,
    FsFormatDatePipe,
    FsMilesToDistancePipe,
    FsReverseArrayPipe,
    FsStateConvertPipe,
    FsFormatColorPipe,
    FsPhoneNumberPipe,
  ],
  providers: [FsFormatDatePipe],
})
export class SnCommonModule {}
